import { render, staticRenderFns } from "./_texte.vue?vue&type=template&id=553385c9"
import script from "./_texte.js?vue&type=script&lang=js&external"
export * from "./_texte.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports